module.exports = __webpack_public_path__ + "public/Icons/darkModeVerified.svg?02f2b976";